import { createRouter, createWebHashHistory, RouteRecordRaw, useRouter } from 'vue-router'

import {
  HomeRoute, HomeRoutePath, HomeRouteName,
} from '@/views';

export const MyRouter = () => useRouter()

export const RoutePath = {
  ...HomeRoutePath,
}

export const RouteName = {
  ...HomeRouteName,
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: RoutePath.school,
  },
  ...HomeRoute,
]

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title as string || window.proName;
  next();
})

export default router
